var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinumLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.5,
    fill: "#758295",
    fillOpacity: 0.2,
    stroke: "#758295",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.234 38.79V41.676H41.256V38.79H32.234ZM32.234 30.886V33.616H41.256V30.886H32.234ZM30.882 23.034V43.314H33.898V25.92H40.008V43.106H43.18V23.034H30.882ZM34.99 18.9C34.834 20.616 34.418 23.008 34.028 24.542L36.836 24.906C37.226 23.476 37.72 21.318 38.162 19.238L34.99 18.9ZM22.562 18.952C21.938 21.5 20.82 23.996 19.468 25.66C19.936 26.388 20.69 28.026 20.95 28.702C22.848 26.492 24.408 23.008 25.318 19.706L22.562 18.952ZM23.004 21.916L22.432 24.828H30.128V21.916H23.004ZM23.914 43.184C24.434 42.638 25.318 42.066 30.154 39.206C29.894 38.582 29.608 37.334 29.504 36.502L24.2 39.466L23.368 40.454L23.914 43.184ZM21.704 26.804V29.586H29.244V26.804H21.704ZM20.326 32.056V34.838H30.076V32.056H20.326ZM23.914 43.184C23.914 42.17 26.774 39.934 26.774 39.934V27.402H23.992V38.27C23.992 39.674 23.03 40.714 22.432 41.156C22.9 41.598 23.654 42.612 23.914 43.184Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumLevel);
export default __webpack_public_path__ + "static/media/platinum_level.327ddd1081b08d13e286469e1326e843.svg";
export { ForwardRef as ReactComponent };